"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSignMethodValid = exports.SignMethodSchema = void 0;
const zod_1 = require("zod");
const bufferSchema_1 = require("./bufferSchema");
const KeyPairSchema = zod_1.z.object({
    privKey: bufferSchema_1.BufferSchema,
    pubKey: bufferSchema_1.BufferSchema,
});
const SignatureProviderSchema = zod_1.z.object({
    pubKey: bufferSchema_1.BufferSchema,
    sign: zod_1.z.function().args(bufferSchema_1.BufferSchema).returns(zod_1.z.promise(bufferSchema_1.BufferSchema)),
});
exports.SignMethodSchema = zod_1.z.union([KeyPairSchema, SignatureProviderSchema]);
const isSignMethodValid = (signMethod, options) => {
    const signMethodValidationCtx = exports.SignMethodSchema.safeParse(signMethod);
    const { throwOnError = false } = options || {};
    const hasError = "error" in signMethodValidationCtx;
    if (!hasError) {
        return { success: true };
    }
    const message = "Invalid sign method";
    if (throwOnError) {
        throw new Error(message);
    }
    return {
        success: false,
        error: signMethodValidationCtx.error,
        message,
    };
};
exports.isSignMethodValid = isSignMethodValid;
//# sourceMappingURL=signMethod.js.map